var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "parameter-edit-modal",
        title:
          _vm.$t("Editar Parâmetro") +
          ": " +
          (_vm.parameter.name || _vm.parameter.key || ""),
        size: "lg",
        "hide-footer": "",
        "no-close-on-backdrop": _vm.loading,
        "no-close-on-esc": _vm.loading,
      },
      on: { shown: _vm.onShown },
    },
    [
      _c(
        "FormulateForm",
        { ref: "form", on: { submit: _vm.save } },
        [
          _vm.validationError
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _vm._v(" " + _vm._s(_vm.validationError) + " "),
              ])
            : _vm._e(),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "param-key",
                      value: _vm.parameter.key,
                      type: "text",
                      label: _vm.$t("Chave"),
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "param-name",
                      value: _vm.parameter.name,
                      type: "text",
                      label: _vm.$t("Nome"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.parameter.name = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "param-description",
                      value: _vm.parameter.description,
                      type: "textarea",
                      label: _vm.$t("Descrição"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.parameter.description = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _vm.isBoolean()
                    ? _c(
                        "div",
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("Valor")))]),
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                switch: "",
                                checked:
                                  _vm.parameter.value === "true" ||
                                  _vm.parameter.value === "True",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.parameter.value = $event
                                    ? "true"
                                    : "false"
                                },
                              },
                              model: {
                                value: _vm.parameter.value,
                                callback: function ($$v) {
                                  _vm.$set(_vm.parameter, "value", $$v)
                                },
                                expression: "parameter.value",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.parameter.value === "true" ||
                                      _vm.parameter.value === "True"
                                      ? _vm.$t("Verdadeiro")
                                      : _vm.$t("Falso")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "small",
                            { staticClass: "text-muted d-block mt-2" },
                            [_vm._v(_vm._s(_vm.getValueHint()))]
                          ),
                        ],
                        1
                      )
                    : _vm.isNumeric()
                    ? _c("FormulateInput", {
                        attrs: {
                          id: "param-value",
                          value: _vm.parameter.value,
                          type: "number",
                          label: _vm.$t("Valor"),
                          validation: "required",
                          hint: _vm.getValueHint(),
                          step: "any",
                          instruction: _vm.parameter.clrType
                            ? _vm.$t("O valor deve ser compatível com o tipo") +
                              ": " +
                              _vm.getTypeName(_vm.parameter.clrType)
                            : "",
                        },
                        on: {
                          input: function ($event) {
                            _vm.parameter.value = $event
                          },
                        },
                      })
                    : _vm.isDateTime()
                    ? _c("FormulateInput", {
                        attrs: {
                          id: "param-value",
                          value: _vm.parameter.value,
                          type: "date",
                          label: _vm.$t("Valor"),
                          validation: "required",
                          hint: _vm.getValueHint(),
                          instruction: _vm.parameter.clrType
                            ? _vm.$t("O valor deve ser compatível com o tipo") +
                              ": " +
                              _vm.getTypeName(_vm.parameter.clrType)
                            : "",
                        },
                        on: {
                          input: function ($event) {
                            _vm.parameter.value = $event
                          },
                        },
                      })
                    : _c("FormulateInput", {
                        attrs: {
                          id: "param-value",
                          value: _vm.parameter.value,
                          type: "textarea",
                          label: _vm.$t("Valor"),
                          validation: "required",
                          hint: _vm.getValueHint(),
                          instruction: _vm.parameter.clrType
                            ? _vm.$t("O valor deve ser compatível com o tipo") +
                              ": " +
                              _vm.getTypeName(_vm.parameter.clrType)
                            : "",
                        },
                        on: {
                          input: function ($event) {
                            _vm.parameter.value = $event
                          },
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end gap-2" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-primary",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Cancelar")) + " ")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.loading },
                      on: { click: _vm.save },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.loading
                              ? _vm.$t("Salvando...")
                              : _vm.$t("Salvar")
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }